import { SvgIcon , SvgIconProps} from '@mui/material';
import './ccf-thumbs-up-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfThumbsUpIconProps extends SvgIconProps  {}

/**
 *
 * @param props -
 * @example
 * @returns
 */
export function CcfThumbsUpIcon(props: CcfThumbsUpIconProps) {
  return (
    <SvgIcon
      {...props}
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
    >
      <path
        d="M17.871 7.27304C17.6181 6.96911 17.3015 6.72443 16.9437 6.5563C16.5858 6.38817 16.1954 6.30069 15.8 6.30004H11.7L12.2 5.01304C12.4096 4.44961 12.4794 3.84375 12.4035 3.24741C12.3275 2.65108 12.1081 2.08206 11.764 1.58916C11.4198 1.09625 10.9613 0.694171 10.4276 0.417394C9.89396 0.140618 9.30115 -0.00259561 8.7 3.56119e-05C8.52688 0.000396838 8.35753 0.0506833 8.21226 0.144866C8.067 0.239049 7.95198 0.37313 7.881 0.531035L5.315 6.30004H3.2C2.48392 6.30004 1.79716 6.5845 1.29081 7.09085C0.784464 7.5972 0.5 8.28395 0.5 9.00004V15.3C0.5 16.0161 0.784464 16.7029 1.29081 17.2092C1.79716 17.7156 2.48392 18 3.2 18H14.658C15.2896 17.9998 15.9012 17.7782 16.3863 17.3737C16.8714 16.9691 17.1993 16.4073 17.313 15.786L18.456 9.48604C18.5265 9.09683 18.5107 8.69688 18.4096 8.31447C18.3085 7.93207 18.1247 7.57654 17.871 7.27304ZM5 16.2H3.2C2.9613 16.2 2.73239 16.1052 2.5636 15.9364C2.39482 15.7676 2.3 15.5387 2.3 15.3V9.00004C2.3 8.76134 2.39482 8.53242 2.5636 8.36364C2.73239 8.19486 2.9613 8.10004 3.2 8.10004H5V16.2ZM16.7 9.16104L15.557 15.461C15.5187 15.6707 15.4072 15.8599 15.2423 15.9951C15.0775 16.1302 14.8701 16.2025 14.657 16.199H6.8V7.39004L9.248 1.88204C9.49966 1.95566 9.73336 2.08058 9.93438 2.24893C10.1354 2.41728 10.2994 2.62542 10.4161 2.86025C10.5327 3.09507 10.5995 3.35151 10.6123 3.61341C10.625 3.87531 10.5834 4.13701 10.49 4.38204L10.014 5.67004C9.91227 5.9423 9.87799 6.23516 9.91408 6.52356C9.95017 6.81196 10.0556 7.08733 10.2213 7.32613C10.3869 7.56493 10.608 7.76006 10.8655 7.89483C11.123 8.0296 11.4093 8.10001 11.7 8.10004H15.8C15.9321 8.10116 16.0624 8.13075 16.1821 8.18681C16.3017 8.24286 16.4079 8.32405 16.4933 8.42485C16.5787 8.52565 16.6414 8.64367 16.6771 8.77089C16.7127 8.89811 16.7206 9.03152 16.7 9.16203V9.16104Z"
        fill="black"
      />
    </SvgIcon>
  );
}

export default CcfThumbsUpIcon;
